import {useState, useMemo, useEffect} from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import {useDebouncedEffect} from '@ozgene/gp5.hooks.use-debounced-effect';
import {getStringChangeHandler} from '@ozgene/gp5.utils.data-functions';
import {validateUniqueUnits} from 'Consumables/service/ConsumableService';

export default function MetricUnitEditor(props) {
  const {entity, onPropertyChange, onValidityChange} = props;
  const {name = '', id} = entity;
  const [nameErrorText, setNameErrorText] = useState('');
  const [isValidating, setIsValidating] = useState(false);
  const handleChangeName = getStringChangeHandler('name', onPropertyChange);
  const isNameInvalid = useMemo(
    () => !name || !!nameErrorText,
    [name, nameErrorText],
  );

  useDebouncedEffect(
    () => {
      const validateName = async () => {
        setNameErrorText(await validateUniqueUnits(name, id));
        setIsValidating(false);
      };

      return validateName();
    },
    [name],
    500,
  );
  useEffect(() => {
    setIsValidating(true);
  }, [name]);
  useEffect(
    () => onValidityChange(!isValidating && !isNameInvalid),
    [isValidating, isNameInvalid, onValidityChange],
  );

  return (
    <TextField
      maxLength="100"
      type="text"
      value={name}
      label="Units"
      fullWidth
      onChange={handleChangeName}
      error={isNameInvalid}
      helperText={nameErrorText}
      inputProps={{maxLength: 50}}
    />
  );
}

MetricUnitEditor.propTypes = {
  entity: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  onPropertyChange: PropTypes.func.isRequired,
  onValidityChange: PropTypes.func.isRequired,
};

MetricUnitEditor.defaultProps = {
  entity: null,
};
